module.exports = __webpack_public_path__ + "static/media/success-old.5c5deb6b.png";